<template>
	<div>
    <div v-if="resolver.timeRangeEnabled">
  		<!--<div><b>Seleziona una fascia oraria</b></div>
  		<div>Riceverai un sms il giorno della consegna che ti avviserà dell'arrivo del corriere e dal codice di tracciamento potrai monitorare in tempo reale il percorso della tua Food Box.</div>-->
  		<div class="flex flex-vcenter form">
  			<label class="text-body-small">
  				Dalle
					<select v-model="start" class="form-control">
						<option 
							:value="null" 
							v-if="resolver.getFrom() && resolver.getFrom().length === 0"
							v-html="'Fascia oraria non disponibile'"
						>
						</option>
						<option v-for="hour in resolver.getFrom()" :value="hour" :key="hour">
							{{hour}}
						</option>
					</select>
  			<!-- 	<select
  					v-model="start"
  					class="form-control"
  				>
  					<option
  						:value="null"
  						v-if="from && from.length == 0"
  						v-html="`Fasce orarie non disponibile`"
  					/>

  					<option
  						:value="h.h"
  						v-for="(h, index) in from"
  						v-html="h.h"
  						v-else
  					/>
  				</select> -->
  			</label>
  		
  			<label class="text-body-small">
  				alle
					<select v-model="end" class="form-control">
						<option 
							:value="null" 
							v-if="resolver.getToByFrom(start) && resolver.getToByFrom(start).length === 0"
							v-html="'Fascia oraria non disponibile'"
						>
						</option>
						<option v-for="range in resolver.getToByFrom(start)" :value="range.to" :key="range.to">
							{{range.to}}  <span v-if="range.price > 0">(+ {{ range.price }} {{ $t('general.currency') }})</span>
  						<!--<span v-if="range.price === 0">(gratuita)</span>-->
						</option>
					</select>
  			</label>	


  		</div>
    </div>
    <div v-if="!resolver.timeRangeEnabled">
      <i class="text-body-small">Nessuna fascia oraria selezionabile per il tuo cap.<br> Fascia di consegna disponibile: 09:00 - 18:00</i>
    </div>
	</div>
</template>

<script>

import { shipmentZonesStore } from '../../store/shipmentZonesStore'
import { subscriptionStore } from '../../store/subscriptionStore'
import { deliveryStore } from '../../store/deliveryStore'
import { milkmanStore } from '../../store/milkmanStore'
import { orderStore } from '../../store/orderStore'
import { DeliveryResolver } from '../../core/delivery/DeliveryResolver'

const moment = require('moment')

export default {
	props: {
		resolver: {
			type: DeliveryResolver,
			required: true
		},
    value: {
      type: Object,
      required: true
    }
	},
	data () {
		return {
			deliveryStore: deliveryStore.state,
			subscriptionStore: subscriptionStore.state,
			shipmentZonesStore: shipmentZonesStore.state,
			milkmanStore: milkmanStore.state,
			from: null,
			to: null,
		}
	},

	watch: {
		'resolver.state.hoursObj': {
			handler () {
				if (!this.start) {
					this.updateStartSelect()
				}

				if (!this.end) {
					this.updateEndSelect()
				}
			},
			immediate: false
		},
	},

	computed: {
		start: {
			get () {
				return this.value.start
					&& this.value.start.slice(0, -3)

				return param;
			},

			set (val) {
				this.value.start = val ? val + ':00' : null
        this.$emit('change')
			}
		},

		end:{
			get () {
				return this.value.end
					&& this.value.end.slice(0, -3)
			},

			set (val) {
				this.value.end = val ? val + ':00' : null
        this.$emit('change')
			}
		},

		price () {
			return this.to.find(i => i.h === this.end).price
		}
	},

	methods: {
		getFirstStart() {
			let ranges = this.resolver.getFrom()

			return ranges.length > 0 ? ranges[0] : null
		},
		getLastEnd() {
			let ranges = this.resolver.getToByFrom(this.start)

			return ranges.length > 0 ? ranges[ranges.length - 1].to : null
		},
		updateEndSelect () {
			if (!this.resolver.getToByFrom(this.start).includes(this.start)) {
				this.end = this.getLastEnd()
			}
		},
		updateStartSelect () {
			if (!this.resolver.getFrom().includes(this.start) && this.getFirstStart()) {
				this.start = this.getFirstStart()
			}
		},
		check() {
			(!this.start || !this.resolver.getFrom().find(x => x == this.start)) && this.updateStartSelect()
			!this.end && this.updateEndSelect() 
		}
	},

	mounted () {
		this.resolver.loadTimeRange();
		this.check()
	},
}

</script>

<style scoped>

.form {
	flex-wrap: wrap;
	text-align: left;
	margin: 0 -5px;
}

.form >>> label {
	flex-basis: 50%;
	padding: 0 5px;
}

@media (max-width: 768px) {
  .form {
    display: block;
  }

  .form > label {
    display: block;
  }
}
</style>
